import { render, staticRenderFns } from "./Radiation.vue?vue&type=template&id=817fbc22&scoped=true"
import script from "./Radiation.vue?vue&type=script&lang=js"
export * from "./Radiation.vue?vue&type=script&lang=js"
import style0 from "./Radiation.vue?vue&type=style&index=0&id=817fbc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817fbc22",
  null
  
)

export default component.exports